import { Breakpoints } from '@unmind/design-system/theme/deprecated';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { small, medium, large } from '../../utils';

const Container = styled.div<{
  removeMargin?: boolean;
}>`
  padding-left: ${rem(24)};
  padding-right: ${rem(24)};

  ${({ removeMargin }) =>
    !removeMargin &&
    css`
      margin: 0 auto;
    `};

  width: 100%;

  ${small(css`
    padding-left: ${rem(32)};
    padding-right: ${rem(32)};
    max-width: ${rem(Breakpoints.S)};
  `)}

  ${medium(css`
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
    max-width: ${rem(Breakpoints.M)};
  `)}
  
  ${large(css`
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
    max-width: ${rem(Breakpoints.L)};
  `)}
`;

export default Container;
